var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "viewer",
          rawName: "v-viewer",
          value: { toolbar: false },
          expression: "{ toolbar: false }"
        }
      ]
    },
    [
      _vm.attachment.type === "image"
        ? _c("img", {
            staticClass: "max-h-72",
            attrs: { src: _vm.attachment.downloadURL }
          })
        : _vm._e(),
      _vm.attachment.type === "sticker"
        ? _c("img", {
            staticClass: "max-h-36",
            attrs: { src: _vm.attachment.downloadURL }
          })
        : _vm._e(),
      _vm.attachment.type === "audio"
        ? _c("audio", {
            staticClass: "max-h-72",
            attrs: { src: _vm.attachment.downloadURL, controls: "" }
          })
        : _vm._e(),
      _vm.attachment.type === "video"
        ? _c("video", {
            staticClass: "max-h-72",
            attrs: { src: _vm.attachment.downloadURL, controls: "" }
          })
        : _vm._e(),
      _vm.attachment.type === "file"
        ? _c("div", [
            _c("div", { staticClass: "flex" }, [
              _c("div", { staticClass: "flex" }, [
                _c(
                  "svg",
                  {
                    staticClass: "flex-shrink-0 h-5 w-5 text-gray-400",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20",
                      fill: "currentColor",
                      "aria-hidden": "true"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        d:
                          "M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z",
                        "clip-rule": "evenodd"
                      }
                    })
                  ]
                ),
                _c("span", { staticClass: "ml-2 flex-1 " }, [
                  _vm._v(" " + _vm._s(_vm.attachment.name) + " ")
                ])
              ]),
              _c("div", { staticClass: "ml-4 flex-shrink-0" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "font-medium text-blue-600 hover:text-blue-500",
                    attrs: {
                      target: "_blank",
                      href: _vm.attachment.downloadURL
                    }
                  },
                  [_vm._v(" Download ")]
                )
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }